// CRMM IA — api-client unico do proxy (Fase 2). accountId vem da URL (idioma do ApiClient.js).
export async function crmmApi(feature, body) {
  const accountId = window.location.pathname.split('/')[3];
  const res = await window.axios.post('/api/v1/accounts/' + accountId + '/crmm/' + feature, body || {});
  return res.data === '' ? null : res.data;
}
